import React, { useState } from "react";
import cancelIcon from "../assets/images/cancel.png";
import editIcon from "../assets/images/edit.svg";
import { useDeleteTodoMutation, useSelectColorMutation, useToggleStatusMutation } from "../features/api/apiSlice";
import EditForm from "./EditForm";
import Spinner from "./ui/Spinner";

const TodoItem = ({ todo }) => {
  const { id, text, color, completed } = todo;
  const [deleteTodo, { isLoading: deleteLoading }] = useDeleteTodoMutation();
  const [toggleStatus, { isLoading: toggleLoading }] = useToggleStatusMutation();
  const [selectColor, { isLoading: colorLoading }] = useSelectColorMutation();
  const [editMode, setEditMode] = useState(false);

  const handleStatusChange = () => {
    toggleStatus({ id, completed });
  };

  const handleDelete = () => {
    deleteTodo(id);
  };
  const handleSelectColor = (color) => {
    selectColor({ id, color });
  };
  return (
    <>
      <div className='flex justify-start items-center p-2 hover:bg-gray-100 hover:transition-all space-x-4 border-b border-gray-400/20 last:border-0'>
        {toggleLoading ? (
          <Spinner customStyle='w-5 h-5 border-2' />
        ) : (
          <div
            className={`rounded-full bg-white border-2 border-gray-400 w-5 h-5 flex flex-shrink-0 justify-center items-center mr-2 ${
              completed && "border-green-500 focus-within:border-green-500"
            }`}
          >
            <input
              checked={completed}
              type='checkbox'
              className='opacity-0 absolute rounded-full'
              onChange={() => handleStatusChange(id, completed)}
            />
            <svg
              className={`${!completed && "hidden"} fill-current w-3 h-3 text-green-500 pointer-events-none`}
              viewBox='0 0 20 20'
            >
              <path d='M0 11l2-2 5 5L18 3l2 2L7 18z' />
            </svg>
          </div>
        )}

        <div className={`select-none flex-1 ${completed && "line-through"}`}>{text}</div>
        <button onClick={() => setEditMode(true)}>
          <img className=' w-6 h-6  cursor-pointer' src={editIcon} alt='edit' />
        </button>
        <div
          onClick={() => handleSelectColor("green")}
          className={` ${
            colorLoading && "pointer-events-none"
          } flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer border-green-500 hover:bg-green-500 ${
            color === "green" && "bg-green-500"
          }`}
        ></div>

        <div
          onClick={() => handleSelectColor("yellow")}
          className={` ${
            colorLoading && "pointer-events-none"
          } flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer border-yellow-500 hover:bg-yellow-500 ${
            color === "yellow" && "bg-yellow-500"
          }`}
        ></div>

        <div
          onClick={() => handleSelectColor("red")}
          className={` ${
            colorLoading && "pointer-events-none"
          } flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer border-red-500 hover:bg-red-500 ${
            color === "red" && "bg-red-500"
          }`}
        ></div>

        {deleteLoading ? (
          <Spinner customStyle='w-4 h-4 border-2' />
        ) : (
          <button onClick={handleDelete} disabled={deleteLoading}>
            <img src={cancelIcon} className='flex-shrink-0 w-4 h-4  cursor-pointer' alt='Cancel' />
          </button>
        )}
      </div>
      {editMode && <EditForm todo={todo} setEditMode={setEditMode} />}
    </>
  );
};

export default TodoItem;
